import React, {Component} from "react";

import Header from "../parts/Header/Header";
import Footer from "../parts/Footer/Footer";
import AboutEpa from "../parts/Citation/CitationAboutEpa";
import Evidence from "../parts/Citation/CitationEvidence";
import Information from "../parts/Citation/CitationInformation";
import {EpaComments} from "../parts/Dossier/EpaComments";
import {citationFetchData} from "../../actions/citation";
import {connect} from "react-redux";


class Citation extends Component {

    componentDidMount() {
        this.props.fetchData(`https://psytable-api.herokuapp.com/api/citation/${this.props.match.params.category}/${this.props.match.params.citationId}`);
    }


    constructor(props) {
        super(props);
        this.state = {
            category : props.match.params.category,
            citationId : props.match.params.citationId,
        };

    }

    getUnique = () =>{
        let un = []
        if (this.props.parentEpa !== ''){
            let temp = this.props.parentEpa
            if (un.includes(temp)){
            }
            else{
                un.push(temp)
            }
            return un.toString().trim()
        }
    }

render()
{
    return (
        <>
            <Header/>
            <main className="main">
                <AboutEpa parentEpa={this.getUnique()}/>
                <Information category={this.state.category} citationId={this.state.citationId}/>
                <Evidence/>
                <EpaComments/>
            </main>
            <Footer/>
        </>
    )
}


}

const mapStateToProps = (state) => {
    return {
        citation: state.citation,
        parentEpa: state.citation.map((item) => item.parentEpa)
    };
};


const mapDispatchToProps = dispatch => {
    return {
        fetchData: url => dispatch(citationFetchData(url)),
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(Citation);
